<section class="subscription-product">
  <header class="subscription-product__header">
    <h4 class="subscription-product__title">{{ title() }}</h4>

    <div class="subscription-product__status">
      <!-- Switched off but not stopped yet: "inactive" would be untrue, so the
           window is named rather than labelled with a state it is not in. -->
      @if (ending()) {
        <umss-badge
          variant="warning"
          [label]="'Ends ' + (lastActiveOn() | date: 'MMM d, y')"
          [outlined]="false"
        />
      } @else {
        <span
          class="subscription-product__status-label"
          [class.pg-small-medium]="readonly_()"
          [class.pg-small-regular]="!readonly_()"
          [class.subscription-product__status-label--muted]="!checked()"
        >
          {{ statusLabel() }}
        </span>
      }

      <!-- The switch stays through the ending window: turning it back on is how
           the facility keeps the product. -->
      @if (readonly_()) {
        @if (checked()) {
          <umss-icon
            name="phosphorCheckCircleBold"
            size="20px"
            color="var(--color-icon-active)"
          />
        }
      } @else {
        <umss-switch
          [checked]="checked()"
          [disabled]="disabled()"
          [ariaLabel]="title() + ' subscription'"
          (change)="activeChange.emit($event)"
        />
      }
    </div>
  </header>

  <p class="subscription-product__description pg-small-regular">
    {{ description() }}
  </p>

  <!-- The three things a facility needs here: it still works, no further
       charge, and how to keep it. -->
  @if (ending()) {
    <p class="subscription-product__ending pg-small-regular">
      Still active until {{ lastActiveOn() | date: 'MMM d, y' }} — you won't be
      charged again. Turn it back on to keep it.
    </p>
  }

  <ng-content />
</section>
